class ContactFormState extends HTMLElement {
    constructor() {
      super();
  
      this.formInputs = this.querySelectorAll('input,select,textarea');
      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('.form-submit-button');
    
      this.formInputs.forEach((input) => {
        input.addEventListener('input', this.onInputChange.bind(this));
        input.addEventListener('blur', this.onInputChange.bind(this));
      });

      this.fileupload = this.querySelectorAll('input[type=file]');
      this.fileupload.forEach((input) => {
        input.addEventListener('change', (event) => {
          this.filesArray = this.filesArray || [];
          Array.from(event.target.files).forEach((file) => {
            this.filesArray.push(file);
            this.addUploadedFile(file);
          });
        });
      });

  
      if (this.form) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.accountCheckboxes = this.querySelectorAll('.form__facet-checkbox input');
    }
  
    connectedCallback() {
      this.accountCheckboxes.forEach((checkbox) => {
        checkbox.addEventListener('change', this.onCheckboxChange.bind(this));
      });

    }

    onCheckboxChange(event) {
        if (event.target && event.target.checked) {
            const dataName = event.target.getAttribute('data-name');
            const template = this.querySelector('template.account-details-template');
            if (template) {
                const clone = document.importNode(template.content, true);
                const parent = event.target.closest('.account-details-block');
                if (parent) {
                    const inputTitle = clone.querySelector('.input-title');
                    if (inputTitle) {
                        inputTitle.textContent = dataName;
                    }
                    clone.firstElementChild.setAttribute('data-nameblock', dataName);

                    const dataLabels = clone.querySelectorAll('[data-label]');
                    dataLabels.forEach((element) => {
                      const originalLabel = element.getAttribute('data-label');
                      if(originalLabel){
                        element.setAttribute('data-label', `${dataName} ${originalLabel}`);
                      }
                    });
                    parent.appendChild(clone);
                }
              this.formContent = this.querySelectorAll('[data-label]');
            }
        } else if (event.target && !event.target.checked) {
            const parent = event.target.closest('.account-details-block');
            if (parent) {
                const elementToRemove = parent.querySelector(`[data-nameblock="${event.target.getAttribute('data-name')}"]`);
                if (elementToRemove) {
                    parent.removeChild(elementToRemove);
                }
            }
        }
    }
  
    onInputChange(event) {
      this.handleInputCheck(event.target);
    }
  
    onSubmitHandler(event) {
      event.preventDefault();
      const formData = this.createFormData();

      let valid = true;
  
      this.formInputs.forEach((input) => {
        if (!this.handleInputCheck(input)) {
          valid = false;
        }
      });
  
      if (!valid || !this.areRequiredCheckboxesChecked()) {
        return;
      }

      const submitButton = this.querySelector(".button.form-submit-button")
      submitButton.classList.add("loading");
      
      fetch(`https://drniedermaier.de/apps/dnp-app/send_mail`, {
          method: "POST",
          body: formData,
      })
      .then((response) => {
        const errorMessage = this.querySelector(".form__message.form-error");
        const successMessage = this.querySelector(".form__message.form-success");
          if(response.ok) {
            if (errorMessage) {
              errorMessage.classList.add('hidden');
            }
            const submitInfo = this.querySelector(".submit-data-notice");
            if(successMessage)
              successMessage.classList.remove('hidden');
            if(submitInfo)
              submitInfo.classList.add('hidden');
          } else {
            if(successMessage)
              successMessage.classList.add('hidden');
            if (errorMessage) {
              errorMessage.classList.remove('hidden');
            }
          }
      })
      .catch((error) => {
        console.error("Error:", error);
        const errorMessage = this.querySelector(".form__message.form-error");
        if (errorMessage) {
          errorMessage.classList.remove('hidden');
        }
      })
      .finally(() => {
          submitButton.classList.remove("loading");
      });
    }
  
    handleInputCheck(input) {
      if (input.classList.contains('required')) {
  
        if (input.value.length === 0 || input.value === input.dataset.empty) {
          input.classList.remove('valid');
          input.classList.add('invalid');
  
          return false;
        }
        else {
          input.classList.remove('invalid');
          input.classList.add('valid');
  
          return true;
        }
      }

      return true;
    }

    createFormData(){
      const formContent = this.querySelectorAll('[data-label]');

      const finalFormData = new FormData();
      let requestBody = {};

      // ADD RECIPIENT
      const recipientEmail = this.querySelector(".form-contact-mail")?.dataset.label;
      if (recipientEmail) {
        requestBody.recipient = recipientEmail;
      }

      // ADD SUBJECT
      const subject = this.querySelector(".title-wrapper")?.innerText;
      if(subject){
        requestBody.subject = "Neues " + subject;
      } else {
        requestBody.subject = "Neues Formular";
      }

      // ADD CC (NOT NEEDED ATM)
      // const ccMails = this.querySelector(".form-contact-mail")?.dataset.cc;
      // if(ccMails){
      //   finalFormData.append('cc', ccMails);
      // } else {
      requestBody.cc = [];
        // finalFormData.append('cc', JSON.stringify([]));
      // }

      // ADD INPUTS ARRAY
      const inputs = [];

      for (let index = 0; index < formContent.length; index++) {
        if (formContent[index].type === 'checkbox') {
          continue;
        }
        const element = formContent[index];
        const label = element.getAttribute('data-label');

        const trimmedLabel = label?.trim().replace(/\*$/, '');
        if (label && element.value) {
          inputs.push({ labelName: trimmedLabel, input: element.value });
        } else if(label && element.innerHTML) {
          inputs.push({ labelName: trimmedLabel, input: element.innerHTML });
        }
      }
      requestBody.inputs = inputs;
      finalFormData.append("requestBody", JSON.stringify(requestBody));

      // ADD FILES HERE
      if(this.filesArray){
        Array.from(this.filesArray).forEach((file)=> {
          const fileBlob = new Blob([file], {type: file.type});
          finalFormData.append('files[]', fileBlob, file.name);
        })
      }

      return (finalFormData);
    }

    addUploadedFile(file){
      const parent = this.querySelector('.uploaded-files');
      if(parent){
        const p = document.createElement('p');
        p.textContent = file.name;
        parent.appendChild(p);
      }

    }

    areRequiredCheckboxesChecked(){
      const isCheckboxChecked = this.querySelectorAll('.checkbox-wrapper[required] input[type="checkbox"]:checked');
      const checkBoxWrapper = this.querySelectorAll('.account-details-block .form__label');
      const alertMessage = document.createElement('p');
      alertMessage.className = 'alert-accounts';
      alertMessage.textContent = 'Bitte wähle mindestens einen Account aus.';

      if (isCheckboxChecked.length === 0 && checkBoxWrapper.length > 0) {
        if (!this.querySelector('.alert-accounts')) {
          checkBoxWrapper[0].insertAdjacentElement('afterend', alertMessage.cloneNode(true));
        }
        return false;
      } else if (checkBoxWrapper.length > 0) {
        const alert = this.querySelector('.alert-accounts');
        if (alert) {
          alert.remove();
        }
        return true;
      }
      return true;
    }
  }
  customElements.define('contact-form-state', ContactFormState);